<footer class="footer">
    <div class="container-fluid">
        <div class="row text-dark">
            <div class="col-sm-6">
               © Enecon - {{year}}
            </div>
            <div class="col-sm-6">
                <div class="text-sm-end d-none d-sm-block">
                    {{ version }}
                </div>
            </div>
        </div>
    </div>
</footer>